module.exports = __webpack_public_path__ + "static/img/pic_dkjj_zqgj_city.360e8897.png";